import React, { useEffect, useRef } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import PaymentSuccess from "@/pages/PaymentSuccess";
import Home from "@/pages/Home";
import Studio from "@/pages/Studio";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex flex-col items-center justify-center gap-4 bg-ink text-paper font-body text-center px-6">
          <div className="font-display text-5xl text-pumpkin text-glow-orange animate-flicker">
            Oops! A friendly ghost hiccuped
          </div>
          <button
            data-testid="error-reload-btn"
            className="px-6 py-3 rounded-full bg-pumpkin text-ink font-semibold"
            onClick={() => window.location.reload()}
          >
            Try again
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

function ScrollFlow() {
  const { pathname } = useLocation();
  const lenisRef = useRef(null);

  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, wheelMultiplier: 1.05 });
    lenisRef.current = lenis;
    window.__lenis = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  useEffect(() => {
    if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
    else window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

export default function App() {
  return (
    <div className="App grain">
      <BrowserRouter>
        <ErrorBoundary>
          <ScrollFlow />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/color/:pageId" element={<Studio />} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/payment/cancel" element={<Navigate to="/" replace />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <Toaster
            position="top-center"
            toastOptions={{
              style: {
                background: "#1c1826",
                border: "1px solid rgba(255,122,0,0.4)",
                color: "#FFF7EE",
              },
            }}
          />
        </ErrorBoundary>
      </BrowserRouter>
    </div>
  );
}
